import { Loader } from '@loophealth/loop-ui-web-library';
import React from 'react';
import { IModularFamily } from '../../../redux/slices/ModularEnrolmentSlice/types';
import DeleteModularMemberModal from '../DeleteModularMember';
import ManageModularMemberModal from '../ManageModularMember';
import ModularAddOnsModal from '../ModularAddOnsModal';
import ModularEnrolmentHeader from '../ModularEnrolmentHeader';
import DisplayDependents from './DisplayDependents';
import { IAction, useAddDependents } from './hooks/useAddDependents';
import ModularValidationDependentModal from './ModularValidationDependentModal';
import { StyledAddDependentsContainer, StyledContainer, StyledLoaderContainer } from './styles';

const ModularAddDependents: React.FC = () => {
    const {
        relations,
        getMembersToDisplay,
        currentMapping,
        targetMapping,
        getTitle,
        setSelectedParentOption,
        addMemberModal,
        setAddMemberModal,
        formValues,
        formErrors,
        onAddCardClick,
        handleFormChange,
        relationshipValues,
        currentAction,
        editMemberModal,
        setEditMemberModal,
        onEditCardClick,
        isLoading,
        onSaveDetails,
        crudLoading,
        setDeleteMemberModal,
        deleteMemberModal,
        onDeleteClick,
        onDeleteMember,
        nonUpgradedRelations,
        validationModal,
        setValidationModal
    } = useAddDependents();

    const showSelfOnly =
        relations[0] === 'Self' &&
        relations.some((relation) => relation.includes('Sibling') || relation.includes('Parents')) &&
        !relations.some((relation) => relation.includes('Spouse'));

    return (
        <StyledContainer>
            <ModularEnrolmentHeader
                title={'Who do you want to cover?'}
                subtitle={'Add your family members to the policy for comprehensive coverage'}
            />
            {isLoading ? (
                <StyledLoaderContainer>
                    <Loader />
                </StyledLoaderContainer>
            ) : (
                <>
                    <ModularAddOnsModal />
                    <StyledAddDependentsContainer>
                        {Array.from(Array(relations.length ?? 0), (_element, index) => {
                            if (
                                relations.length === 1 ||
                                relations[index] !== 'Self' ||
                                index !== 0 ||
                                (showSelfOnly && index === 0)
                            ) {
                                return (
                                    <DisplayDependents
                                        key={index}
                                        title={getTitle(index)}
                                        relation={relations[index]}
                                        membersToDisplay={getMembersToDisplay(relations[index])}
                                        currentMapping={currentMapping}
                                        targetMapping={targetMapping}
                                        onAddMemberClick={() => onAddCardClick(relations[index])}
                                        onMemberEditClick={(dep: IModularFamily) => onEditCardClick(dep)}
                                        onMemberDeleteClick={(id: string) => onDeleteClick(id, relations[index])}
                                        setSelectedParentOption={setSelectedParentOption}
                                        isUpgraded={nonUpgradedRelations[index] !== relations[index]}
                                    />
                                );
                            }
                        })}
                    </StyledAddDependentsContainer>
                </>
            )}
            <ManageModularMemberModal
                isVisible={currentAction === IAction.ADD ? addMemberModal : editMemberModal}
                setIsVisible={currentAction === IAction.ADD ? setAddMemberModal : setEditMemberModal}
                formValues={formValues}
                formErrors={formErrors}
                relationshipValues={relationshipValues}
                isLoading={crudLoading}
                onSubmit={onSaveDetails}
                handleFormChange={(e, type) => handleFormChange(e, type)}
                currentAction={currentAction}
            />
            <DeleteModularMemberModal
                setIsVisible={setDeleteMemberModal}
                isVisible={deleteMemberModal}
                confirmDelete={onDeleteMember}
                loading={crudLoading}
            />
            <ModularValidationDependentModal
                isVisible={!!validationModal}
                setIsVisible={() => setValidationModal(undefined)}
                validationModal={validationModal}
                onConfirmDelete={onDeleteMember}
                onConfirmUpdate={() => onSaveDetails(false)}
                isSubmitting={crudLoading}
            />
        </StyledContainer>
    );
};

export default ModularAddDependents;
